<div class="confirm-modal">
  <div class="confirm-modal__content">
    <h2 *ngIf="title && type != 'client'" class="confirm-modal__content__title">
      {{ title }}
    </h2>
    <img
      [src]="
        type === 'client'
          ? '../../../assets/img/solde_insuffisant_silver.png'
          : '../../../assets/img/annuler_demande.svg'
      "
      alt="confirm message"
    />
    <p
      *ngIf="description && type != 'client'"
      class="confirm-modal__content__message"
    >
      {{ description }}
    </p>
    <p
      *ngIf="type === 'client'"
      class="confirm-modal__content__message"
      style="display: flex; flex-direction: column"
    >
      <span>
        {{ "MODALS.CONFIRM_CLIENT_CANCEL_DEMAND.MESSAGE_P1" | translate }}
      </span>
      <span>
        {{ "MODALS.CONFIRM_CLIENT_CANCEL_DEMAND.MESSAGE_P2" | translate }}
      </span>
    </p>

    <div class="confirm-modal__content__buttons">
      <app-button
        (click)="cancleOnRoadDemand()"
        expand="full"
        class="btn-active"
        [innerText]="
          validButtonText
            ? validButtonText
            : type === 'client'
            ? ('MODALS.CONFIRM_CLIENT_CANCEL_DEMAND.CONFIRM' | translate)
            : ('GLOBAL.OUI' | translate)
        "
        [disabled]="loading"
        [loading]="loading"
      />
      <app-button
        (onClick)="closeModal()"
        expand="full"
        class="btn-inactive"
        [disabled]="loading"
        [innerText]="
          validButtonText ? validButtonText : ('GLOBAL.NON' | translate)
        "
        [styles]="{ backgroundColor: '#8DADCD' }"
      />
    </div>
  </div>
</div>
